module.exports = __webpack_public_path__ + "media/Speaker_high.87820b1e.mp4";